import * as React from "react";
import Icon from "../../types/Icon.interface";

const IconArrowDown: React.FC<Icon> = (props: Icon) => {
  const { color = "#FFFFFF", size = 32, className, style } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className={className}
      style={style}
    >
      <path
        fill={color}
        d="M24 13.333l-8 6.4-8-6.4 1.067-.533L16 16.533l6.933-3.733z"
      />
    </svg>
  );
};

export default IconArrowDown;
